import React from 'react';
import './SupabaseConfigError.css';

export default function SupabaseConfigError() {
  return (
    <div className="config-error-page">
      <div className="config-error-card">
        <h1>Supabase configuration missing</h1>
        <p>
          The UI could not load Supabase settings. In production (e.g. <strong>Cloud Run</strong>), the
          server must define <code>SUPABASE_URL</code> and <code>SUPABASE_ANON_KEY</code> so{' '}
          <code>GET /api/config</code> can supply them to the browser. Locally, you can instead set{' '}
          <code>REACT_APP_SUPABASE_URL</code> and <code>REACT_APP_SUPABASE_ANON_KEY</code> for Create
          React App.
        </p>
        <ol>
          <li>
            <strong>Cloud Run / Docker:</strong> In the service configuration, set environment variables
            (same project as Task Tracker):
            <pre className="config-error-pre">
{`SUPABASE_URL=https://xxxx.supabase.co
SUPABASE_ANON_KEY=eyJhbGciOiJIUzI1NiIs...
SUPABASE_SERVICE_KEY=...`}
            </pre>
            Redeploy or restart the revision so the container picks them up. No{' '}
            <code>REACT_APP_*</code> build args are required for the SPA when this is set.
          </li>
          <li>
            <strong>Local dev:</strong> In <code>frontend/.env</code> or the repo root <code>.env</code>{' '}
            (with <code>REACT_APP_*</code> names), or rely on <code>npm run dev</code> loading the root{' '}
            <code>.env</code>.
            <pre className="config-error-pre">
{`REACT_APP_SUPABASE_URL=https://xxxx.supabase.co
REACT_APP_SUPABASE_ANON_KEY=eyJhbGciOiJIUzI1NiIs...`}
            </pre>
          </li>
        </ol>
        <p className="config-error-foot">
          After changing env vars, redeploy Cloud Run or restart <code>npm start</code>.
        </p>
      </div>
    </div>
  );
}
